import "../../assets/css/modal.css";
import "../../assets/css/custom.css";
import { useEffect, useRef, useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { useHistory } from "react-router-dom";

export default function LoginModal({ isOpen, onClose }) {
  if (!isOpen) return null;
  const history = useHistory();

  const handlLogin = () => {
    history.push("/login");
  };

  return (
    <div className="modal-mobile-overlay" onClick={onClose}>
      <div
        style={{
          backgroundColor: `white`,
          height: `200px`,
          width: `300px`,
          padding: `20px`,
          borderRadius: `8px`,
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div>
          <div className="modal-mobile-header">로그인이 필요합니다.</div>
          <hr color="black" />
        </div>
        <div>
          <div
            style={{
              display: `flex`,
              justifyContent: `center`,
              color: `#1a77f3`,
            }}
          >
            <FaCheckCircle size={30} />
          </div>
          <div
            style={{
              display: `flex`,
              width: `100%`,
              justifyContent: `center`,
              alignItems: `center`,
              marginTop: `10px`,
              fontWeight: `800`,
            }}
          >
            본서비스는 로그인이 필요한 서비스입니다.
          </div>
          <div
            style={{
              display: `flex`,
              justifyContent: `space-between`,
              marginTop: `10px`,
            }}
          >
            <div
              onClick={onClose}
              style={{
                backgroundColor: `red`,
                display: `flex`,
                justifyContent: `center`,
                alignItems: `center`,
                width: `100%`,
                height: `40px`,
                borderRadius: `8px`,
                fontWeight: `800`,
                fontSize: `16px`,
                color: `white`,
                cursor: `pointer`,
              }}
            >
              닫기
            </div>
            <div style={{ width: `20px` }}></div>
            <div
              onClick={() => handlLogin()}
              style={{
                backgroundColor: `#1a77f3`,
                display: `flex`,
                justifyContent: `center`,
                alignItems: `center`,
                width: `100%`,
                height: `40px`,
                borderRadius: `8px`,
                fontWeight: `800`,
                fontSize: `16px`,
                color: `white`,
                cursor: `pointer`,
              }}
            >
              로그인
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
